export const fieldRequired = (value) => {
  return value && value !== "";
};

export const fieldName = (value) => {
  const re = /^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/g;
  return re.test(value);
};
export const fieldEmail = (value) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(value);
};

export const fieldPhoneNumber = (value) => {
  const re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return re.test(value);
};
export const fieldNumbers = (value) => {
  const re = /^([0-9])*$/;
  return re.test(value);
};

export const fieldNumbersAndLetters = (value) => {
  const re = /^[A-Za-zñÑáéíóúÁÉÍÓÚ0-9/\s]*$/;
  return re.test(value);
};
